module.exports = "<app-navbar [brand]=\"appBrand\"></app-navbar>\n<div class=\"container\" style=\"margin-top: 100px;\">\n    <router-outlet></router-outlet>\n</div>\n\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = 0